module.exports = __webpack_public_path__ + "assets/media/youtube-footer.30985b00.svg";